import {ensureHierarchy, mergeTo} from '#core/utils/config-utils.js';

import {ApplicationConfig} from '#core/config/application-config.js';

import {AbstractVisualFeature, allVisuals} from '#core/application/modules/visual-feature.js';
import {MobileNavBar} from '#core/application/modules/interface/mobile-navbar/index.js';

import {DBXCompactHeader} from './compact-header/compact-header.jsx';

/**
 * Simple feature that adjust presentation if application is embedded into host app
 */
class EmbeddedAppFeature extends AbstractVisualFeature {
    get name() {
        return 'EmbeddedApp';
    }

    get enabled() {
        // Always shows as widget, for application without built-in authorization
        return !BUILT_IN_AUTHORIZATION_UI || ApplicationConfig.isEmbedded;
    }

    updateViewsConfig(viewsConfig) {
        mergeTo(viewsConfig, {
            AppViewSportsbook: {
                quickLinks: {
                    hide:
                        !!ApplicationConfig.initParams.hideBottomNavBar ||
                        MobileNavBar.config.mobileNavigationBarHidden,
                },
            },
            ...(ApplicationConfig.initParams.hidePageBackButton
                ? {
                      PageHeader: {
                          backButton: {
                              button: {
                                  style: {
                                      base: {
                                          display: 'none',
                                      },
                                  },
                              },
                          },
                          labelContainer: {
                              style: {
                                  padding: '0 8px',
                              },
                          },
                      },
                      QuickNavigationButton: {
                          container: {
                              style: {
                                  base: {
                                      padding: '0 8px',
                                  },
                              },
                          },
                      },
                  }
                : {}),
            ...(ApplicationConfig.initParams.betslipButtonBottomOffset !== undefined
                ? {
                      FloatingBetslipPill: {
                          closedBetslipButtonState: {
                              container: {
                                  style: {
                                      transform: `translate(0px, calc(${ApplicationConfig.initParams.betslipButtonBottomOffset}px - env(safe-area-inset-bottom, 0px)))`,
                                  },
                              },
                          },
                      },
                  }
                : {}),
            BetHistoryView: {
                style: {
                    compactTableContainer: {
                        // Following is workaround for to fix infinite scroll issue in portal integrated solution
                        height: '100%',
                        maxHeight: 'calc(100vh - 160px)', // just make container fixed size
                        overflowY: 'scroll',
                        minHeight: '280px',
                        //----
                        wrapInfiniteList: true,
                    },
                },
            },
        });
        super.updateViewsConfig(viewsConfig);
    }

    updateMojitoConfig(mojitoConfig) {
        const header = ensureHierarchy(mojitoConfig, 'services.viewImplementations.ApplicationHeader');
        header.implementation = DBXCompactHeader;

        super.updateMojitoConfig(mojitoConfig);
    }
}

new EmbeddedAppFeature(allVisuals);
